<script setup lang="ts">
interface SectionHeaderProperties {
  label: string;
}

defineProps<SectionHeaderProperties>();
</script>

<template>
  <div class="flex items-center justify-between">
    <span class="text-sm font-medium text-foreground">{{ label }}</span>
    <slot />
  </div>
</template>
